import api from "./api";

// ── Boards ──

export const listBoards = async () => {
  const { data } = await api.get("/kanban-enterprise/boards");
  return data;
};

export const createBoard = async (payload) => {
  const { data } = await api.post("/kanban-enterprise/boards", payload);
  return data;
};

export const showBoard = async (boardId) => {
  const { data } = await api.get(`/kanban-enterprise/boards/${boardId}`);
  return data;
};

export const updateBoard = async (boardId, payload) => {
  const { data } = await api.put(`/kanban-enterprise/boards/${boardId}`, payload);
  return data;
};

export const deleteBoard = async (boardId) => {
  await api.delete(`/kanban-enterprise/boards/${boardId}`);
};

// ── Columns ──

export const createColumn = async (payload) => {
  const { data } = await api.post("/kanban-enterprise/columns", payload);
  return data;
};

export const updateColumn = async (columnId, payload) => {
  const { data } = await api.put(`/kanban-enterprise/columns/${columnId}`, payload);
  return data;
};

export const deleteColumn = async (columnId) => {
  await api.delete(`/kanban-enterprise/columns/${columnId}`);
};

export const reorderColumns = async (payload) => {
  const { data } = await api.put("/kanban-enterprise/columns/reorder", payload);
  return data;
};

// ── Column Tickets ──

export const listColumnTickets = async (columnId, filterJson, pageNumber = 1, limit = 200) => {
  const { data } = await api.get(`/kanban-enterprise/columns/${columnId}/tickets`, {
    params: {
      filterJson: JSON.stringify(filterJson),
      pageNumber,
      limit
    }
  });
  return data;
};

// ── Ticket Actions ──

export const quickUpdateTicket = async (ticketId, payload) => {
  const { data } = await api.put(`/kanban-enterprise/tickets/${ticketId}/quick-update`, payload);
  return data;
};

export const moveTicketToLane = async (ticketId, payload) => {
  const { data } = await api.put(`/kanban-enterprise/tickets/${ticketId}/move-to-lane`, payload);
  return data;
};

export const getTicketAudit = async (ticketId) => {
  const { data } = await api.get(`/kanban-enterprise/tickets/${ticketId}/audit`);
  return data;
};

// ── Column Media Upload ──

export const uploadColumnMedia = async (columnId, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("medias", file));
  const { data } = await api.post(`/kanban-enterprise/columns/${columnId}/media`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

// ── Views ──

export const saveView = async (payload) => {
  const { data } = await api.post("/kanban-enterprise/views", payload);
  return data;
};

export const getView = async (boardId) => {
  const { data } = await api.get(`/kanban-enterprise/views/${boardId}`);
  return data;
};
